import React from "react";
import Skeleton from "@mui/material/Skeleton";
import "./TableSkeletonLoader.scss";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { neutral } from "../../../../constants/colorConstants";

const SkeletonLoader = ({ type, cells }: any) => {
  const classes = `pw-skeleton-${type}`;
  const rows = 10;
  const rowAr = Array.from({ length: rows }, (element, index) => index);
  // const rowAr = new Array(rows)
  // for(let i=0; i<rows; i++){
  //     rowAr.push(i);
  // }
  return (
    <div className="h-70v pw-hide-scroll overflow-y-auto">
      <Table>
        <TableHead className="bg-neutral-50">
          <TableRow className="h-14">
            {cells.map((each: any) => {
              return (
                <TableCell>
                  {each === " " ? (
                    ""
                  ) : (
                    <Skeleton
                      width="70%"
                      sx={{ bgcolor: neutral[200] }}
                      className="pw-skeleton"
                    />
                  )}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody className="bg-white">
          {rowAr.map((each: any) => {
            return (
              <TableRow className="h-14">
                {cells.map((eachCell: any) => {
                  return (
                    <TableCell className="pw-tablecell">
                      {eachCell === " " ? (
                        <Skeleton
                          variant="circular"
                          width="70%"
                          sx={{ bgcolor: neutral[200] }}
                        />
                      ) : (
                        <Skeleton
                          variant={eachCell}
                          width="70%"
                          sx={{ bgcolor: neutral[200] }}
                          className={classes}
                        />
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default SkeletonLoader;
